export default __webpack_public_path__ + "img/label.puroak.04.asset.79e1643d.png";